// Память аналитики на устройстве: когда человек пришёл впервые, какая сессия по счёту, с какой рекламы (первое касание —
// навсегда), какие вехи уже были, платил ли. Хранилище подставное (тесты); недоступно (приватный режим) — живёт до
// перезапуска, вехи тогда могут уйти повторно — их дедуплицирует отчёт по первому событию.
import type { Campaign } from './events';

export interface Store { getItem(k: string): string | null; setItem(k: string, v: string): void }
interface Saved { first: number; sessions: number; touch?: Campaign & { at: number }; done: string[]; payer?: boolean }
const KEY = 'cricket.analytics';

export class Profile {
  private s: Saved;
  constructor(private store: Store | null, now: number) {
    let saved: Saved | null = null;
    try { saved = JSON.parse(store?.getItem(KEY) ?? 'null') as Saved | null; } catch { /* битая запись — начнём заново */ }
    this.s = saved && typeof saved.first === 'number' ? { ...saved, done: saved.done ?? [], sessions: (saved.sessions ?? 0) + 1 } : { first: now, sessions: 1, done: [] };
    this.save();
  }
  private save(): void { try { this.store?.setItem(KEY, JSON.stringify(this.s)); } catch { /* нет места / приватный режим */ } }
  get isNew(): boolean { return this.s.sessions === 1; }
  get sessions(): number { return this.s.sessions; }
  get payer(): boolean { return Boolean(this.s.payer); }
  ageMinutes(now: number): number { return Math.max(0, Math.round((now - this.s.first) / 60_000)); }
  ageDays(now: number): number { return Math.floor(this.ageMinutes(now) / 1440); }
  /** Первое касание: запоминается один раз — у нового человека любое, у старого только рекламное (до того не было). */
  touch(c: Campaign, now: number): Campaign {
    if (!this.s.touch && (this.isNew || c.medium === 'paid')) { this.s.touch = { ...c, at: now }; this.save(); }
    return this.s.touch ?? c;
  }
  /** true — веха случилась впервые (и запомнена). */
  reach(name: string): boolean {
    if (this.s.done.includes(name)) return false;
    this.s.done.push(name); this.save();
    return true;
  }
  markPayer(): void { if (!this.s.payer) { this.s.payer = true; this.save(); } }
}
